// หน้าที่ถูกเอาออก (Vector 2026-10-11) — URL เดิมที่มีคนบุ๊คมาร์กไว้ให้พาไปหน้าที่ใช้แทน
const LEGACY_REDIRECTS = [
    { from: "cargo-load-events", to: "/ShiftAdmin" },
    { from: "PromotionChecker", to: "/customer-purchase-behavior" },
    { from: "sales-report-summary", to: "/accounting-daily-report" }, // ?date= ตามไปด้วย
    { from: "GpsDeviceTokenAdmin", to: "/TabletTokenAdmin" },
];

export default LEGACY_REDIRECTS;
